export default __webpack_public_path__ + "static/media/vehicle.24bc67ac214b32d149849d69eb33a840.svg";